import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { updateStatusDocuments } from "../../../AdminAPI/UpdateStatusDocADM";

export const handleAutoRelaunchDocs = async (
  filteredData,
  t
) => {
  if (!Array.isArray(filteredData) || filteredData.length === 0) {
    toast.warning(t("No document matches the current filters"));
    return;
  }

  const token = Cookies.get("Token");

  // sur les documents filtrés
  const docsToRelaunch = filteredData;

  //  si OldStatus manquant
  const docsWithoutOldStatus = docsToRelaunch.filter(
    (doc) => !doc.OldStatus
  );

  if (docsWithoutOldStatus.length > 0) {
    toast.error(
      t("Some filtered documents have no previous status and cannot be relaunched")
    );
    return;
  }

  //  Status -> OldStatus
  const groups = {};

  for (const doc of docsToRelaunch) {
    if (doc.Status === doc.OldStatus) continue;

    const key = `${doc.Status}|${doc.OldStatus}`;
    if (!groups[key]) {
      groups[key] = {
        currentStatus: doc.Status,
        newStatus: doc.OldStatus,
        docIds: [],
      };
    }
    groups[key].docIds.push(doc.DocId);
  }

  if (Object.keys(groups).length === 0) {
    toast.info(t("No document requires relaunch"));
    return;
  }

  let successCount = 0;
  let errorCount = 0;

  for (const group of Object.values(groups)) {
    try {
      await updateStatusDocuments(
        group.currentStatus,
        group.newStatus,
        JSON.stringify(group.docIds),
        token
      );
      successCount += group.docIds.length;
    } catch (error) {
      console.error("Auto relaunch failed for group:", group, error);
      errorCount += group.docIds.length;
    }
  }

  if (successCount > 0) {
    toast.success(
      t("{{count}} documents relaunched", { count: successCount })
    );
  }

  if (errorCount > 0) {
    toast.error(
      t("{{count}} documents could not be relaunched", {
        count: errorCount,
      })
    );
  }

  setTimeout(() => window.location.reload(), 1500);
};
